import * as React from 'react';

import { createIcon } from '../Icon';
export const CircleFilledIcon = createIcon(
  <circle cx="12" cy="12" r="5" />,
  'CircleFilledIcon'
);
